module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<p>Импорт завершен</p>\n\n<div class=\"row\">\n	<p>Строк в файле: <span>")
    ; __append(escapeFn( data.count ))
    ; __append("</span></p>\n</div>\n\n<div class=\"row\">\n	<p>Добавлено: <span>")
    ; __append(escapeFn( data.inserted ))
    ; __append("</span></p>\n\n	<p>Обновлено: <span>")
    ; __append(escapeFn( data.updated ))
    ; __append("</span></p>\n\n	<p>Пропущено: <span>")
    ; __append(escapeFn( data.skipped ))
    ; __append("</span></p>\n</div>\n\n<div class=\"row\">\n	<button on-click=\"onCloseClick\" class=\"gl-primary-button\">Закрыть</button>\n</div>")
  }
  return __output.join("");

}